import BaseNoviApiRepo from './BaseNoviApiRepo';
import { DtoEvent } from '../types/event/DtoEvent';
import { DtoAttendee, createAttendee, Attendee } from '../types/event/DtoAttendee';
import { DtoTicketsAndAddons, createTicketsAndAddons } from '../types/event/DtoTicketsAndAddons';
import { DtoEventRegistration } from '../types/event/DtoEventRegistration';
import { CouponValidationResult } from '../types/membership/CouponValidationResult';
import { DtoRegistrationResponse } from '../types/event/DtoRegistrationResponse';
import { AxiosResponse } from 'axios';

/**
 * @description Handles API interaction for events
 */
class EventRepo extends BaseNoviApiRepo {    
    getEvent(id: number) {
        return super.get<DtoEvent>(`/novi-api/event/get-event?eventId=${id}`)
            .then(super.getNoviApiDataHandler<DtoEvent>())
            .catch(super.getNoviApiErrorHandler<DtoEvent>());
    }

    loadAttendeeEmailsTicketsMap(id: number): Promise<Array<{ email: string; ticketId: number }>> {
        return super.get<Array<{ email: string; ticketId: number }>>(`/novi-api/event/get-attendee-emails-tickets-map?eventId=${id}`)
            .then(super.getNoviApiDataHandler<Array<{ email: string; ticketId: number }>>())
            .catch(super.getNoviApiErrorHandler<Array<{ email: string; ticketId: number }>>());
    }

    getEligibleAttendees(eventId: number) {
        return super.get<DtoAttendee[]>(`/novi-api/event/get-eligible-attendees?eventId=${eventId}`)
            .then((res: AxiosResponse<DtoAttendee[]>) => res.data.map(attendee => createAttendee(attendee)))
            .catch(super.getNoviApiErrorHandler<Attendee[]>());
    }

    getTicketsAndAddons(eventId: number) {
        return super.get<DtoTicketsAndAddons>(`/novi-api/event/get-tickets-and-addons?eventId=${eventId}`)
            .then((res: AxiosResponse<DtoTicketsAndAddons>) => createTicketsAndAddons(res.data))
            .catch(super.getNoviApiErrorHandler<DtoTicketsAndAddons>());
    }

    register(registrationModel: DtoEventRegistration) {
        return super.post<DtoRegistrationResponse>('/novi-api/event/process-event-checkout', registrationModel)
            .then(super.getNoviApiDataHandler<DtoRegistrationResponse>())
            .catch(super.getNoviApiErrorHandler<DtoRegistrationResponse>());
    }

    validateCoupon(eventId: number, productIds: number[], purchaserId: number, promoCode: string) {
        return super.post<CouponValidationResult>('/novi-api/event/validate-coupon-code', {
            eventId,
            productIds,
            purchaserId,
            promoCode
        })
            .then(super.getNoviApiDataHandler<CouponValidationResult>())
            .catch(super.getNoviApiErrorHandler<CouponValidationResult>());
    }

    checkAttendeeDuplicateEmails(eventId: number, email: string, ticketIds: number[]): Promise<any> {
        return super.post(`/novi-api/event/check-attendee-duplicate-emails?eventId=${eventId}&email=${encodeURIComponent(email)}&ticketIds=${ticketIds}`)
            .then(super.getNoviApiDataHandler<any>())
            .catch(super.getNoviApiErrorHandler<any>());
    }

}

export const eventRepo = new EventRepo();